import styled from 'styled-components';

import {
  Colors,
} from '@noitada/shared/constants';

import {
  SubTitle,
  Title,
} from '../../components/Composh/web';



export const WebViewTitle = styled(Title)`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;
`;

export const WebViewSubTitle = styled(SubTitle)`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;
`;

export const WebViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${Colors.appBackground};
`;

export const WebViewComponent = styled.iframe`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
